import { i18n } from '@/tools/i18n';

export default {
	init() {
		[...this.$el.querySelectorAll('.post--image')].forEach(post => {
			const image = post.querySelector('.element__fullimage');
			if (!image) return;
			// fix structure of post--image. set alt text on image container to fix semantic structure of figures maybe in future this is supported by screen reader
			const altText = post.getAttribute('alt');
			image.setAttribute('role', 'img');
			image.setAttribute('alt', altText);
			// if the post image get's the focus it is redirected to the image this is need especially on page load
			// or if all screenreader elements are empty remove tabindex
			if (altText || post.getElementsByTagName('figcaption')[0].innerText != '') {
				post.addEventListener('focus', () => {
					image.focus();
				});
			} else {
				post.removeAttribute('tabindex');
			}

			const title = post.querySelector('.element__caption__headline');
			if (title) {
				title.setAttribute('role', 'text');
				title.setAttribute('tabindex', 0);
				title.setAttribute('aria-label', `${i18n.t('imageTitle')} ${title.textContent}`);
			}

			const description = post.querySelector('.element__caption__text');
			if (description) {
				description.setAttribute('role', 'text');
				description.setAttribute('tabindex', 0);
				description.setAttribute('aria-label', `${i18n.t('imageDescription')} ${description.textContent}`);
			}

			const attribution = post.querySelector('.element__caption__attribution');
			if (attribution) {
				attribution.setAttribute('role', 'text');
				attribution.setAttribute('tabindex', 0);
				attribution.setAttribute('aria-label', `${i18n.t('imageAttribution')} ${attribution.textContent}`);
			}
		});
	},
	destroy() {},
};
